<template>
  <div class="nav-wrapper">
    <div class="nav-left-inner">
      <!-- 响应式菜单按钮 -->
      <div class="responsive-menu-btn" @click="openDrawer">
        <i class="iconfont icon-liebiao"></i>
      </div>
      <h2 v-if="logoInfo" class="header-inner-middle">
        <div id="header-logo">
          <a href="/" @click.prevent.stop="goHome">
            <NuxtImgWrap
              v-if="currentLogo.value === 0 && logoInfo.logo_image"
              width=""
              height="66"
              :src="`${logoInfo.logo_image}`"
              :style="{ 'aspect-ratio': logoInfo.logo_ratio || 'auto' }"
              alt="Vooglam Eyewear Elevates Your Vision and Style"
              loading="lazy"
            />
            <NuxtImgWrap
              v-if="currentLogo.value === 1 && logoInfo.logo_sub_image"
              width=""
              height="66"
              :src="`${logoInfo.logo_sub_image}`"
              :style="{ 'aspect-ratio': logoInfo.logo_sub_ratio || 'auto' }"
              alt="Vooglam Eyewear Elevates Your Vision and Style"
              loading="lazy"
            />
          </a>
        </div>
      </h2>

      <div class="nav-box">
        <ul v-if="newNavData?.length" class="vooglam-nav scrollbar-none">
          <li
            v-for="(item, index) in newNavData"
            :id="index == 0 ? 'startLi' : index == newNavData.length - 1 ? 'endLi' : ''"
            :key="index"
            class="nav-li"
            :class="[{ on: navIsHover(item?.jump_target) }]"
            :style="getFirstLevelStyle(item)"
            @mouseenter="navMouseEnter(item, index)"
            @mouseleave="navMouseLeave(item, index)"
          >
            <MagicJump
              :item="item.jump_target || EMPTY_JUMP_TARGET"
              :aria-label="item.nav_title"
              :entrancePageScene="'导航栏'"
              class="nav-li-a"
              @jumpComplete="navMouseLeave(item, index)"
            >
              <span
                class="nav-inner-title"
                @click="SDHomeTopNavigationTabClick(item.nav_title, index)"
              >
                <span class="title" :style="{ color: item.nav_title_color ?? '#080506' }">{{
                  item.nav_title
                }}</span>
                <NuxtImgWrap
                  v-if="item.badge?.badge_type === 'image'"
                  class="nav-badge-image nav-title-badge"
                  :src="item.badge.badge_image"
                  :alt="item.badge.alt || item.nav_title"
                />
                <span
                  v-else-if="item.badge?.badge_type === 'text'"
                  class="nav-badge nav-title-badge"
                  :style="{
                    color: item.badge.text_color,
                    backgroundColor: item.badge.fill_color,
                  }"
                >
                  {{ item.badge.text }}
                </span>
              </span>
            </MagicJump>
            <div v-if="(isMounted || isSpider) && hasDropdown(item)">
              <div
                v-show="item?.navShow"
                class="slide-part"
                :class="{ 'has-resource': item.resource_slots?.length }"
              >
                <div class="slide-panel-groups" :id="`slideLeft${index}`">
                  <div
                    v-for="(item2, index2) in item.list"
                    :key="`${index}-${index2}-${item2.nav_title}`"
                    class="second-box"
                    :class="`display-${item2.display_style}`"
                  >
                    <div class="nav-group-title">
                      <p class="item2-title" :style="{ color: item2.nav_title_color ?? '#080506' }">
                        {{ item2.nav_title }}
                      </p>
                      <span
                        v-if="item2.badge?.badge_type === 'text'"
                        class="nav-badge"
                        :style="{
                          color: item2.badge.text_color,
                          backgroundColor: item2.badge.fill_color,
                        }"
                      >
                        {{ item2.badge.text }}
                      </span>
                      <NuxtImgWrap
                        v-else-if="item2.badge?.badge_type === 'image'"
                        class="nav-badge-image"
                        :src="item2.badge.badge_image"
                        :alt="item2.badge.alt || item2.nav_title"
                      />
                    </div>

                    <div
                      v-if="item2.display_style === 'text'"
                      :class="['second-text-box', getTextColumnsClass(item2)]"
                    >
                      <MagicJump
                        v-for="(item3, index3) in item2.list"
                        :key="`${index}-${index2}-${index3}-${item3.nav_title}`"
                        class="magic-jump"
                        :item="item3.jump_target || EMPTY_JUMP_TARGET"
                        :aria-label="item3.nav_title"
                        :entrancePageScene="'导航栏'"
                        @click="handleThirdLevelTrack(index, item, index2, item2, index3, item3)"
                      >
                        <span
                          class="third-level-title"
                          :style="{ color: item3.nav_title_color ?? '#080506' }"
                        >
                          {{ item3.nav_title }}
                        </span>
                        <span
                          v-if="item3.badge?.badge_type === 'text'"
                          class="nav-badge"
                          :style="{
                            color: item3.badge.text_color,
                            backgroundColor: item3.badge.fill_color,
                          }"
                        >
                          {{ item3.badge.text }}
                        </span>
                        <NuxtImgWrap
                          v-else-if="item3.badge?.badge_type === 'image'"
                          class="nav-badge-image"
                          :src="item3.badge.badge_image"
                          :alt="item3.badge.alt || item3.nav_title"
                          loading="lazy"
                        />
                      </MagicJump>
                    </div>

                    <div v-else class="second-image-box">
                      <MagicJump
                        v-for="(item3, index3) in item2.list"
                        :key="`${index}-${index2}-img-${index3}-${item3.nav_title}`"
                        :item="item3.jump_target || EMPTY_JUMP_TARGET"
                        class="second-image-content"
                        :entrancePageScene="'导航栏'"
                        @click="handleImageTrack(index, item, index2, item2, index3, item3)"
                      >
                        <NuxtImgWrap
                          class="second-image-content-img"
                          :src="item3.third_level_image || ''"
                          :alt="item3.alt || `Vooglam ${item2.nav_title}: ${item3.nav_title}`"
                          loading="lazy"
                        />
                        <div class="second-image-btm">
                          <span
                            class="shape-title"
                            :style="{ color: item3.nav_title_color ?? '#080506' }"
                          >
                            {{ item3.nav_title }}
                          </span>
                          <span
                            v-if="item3.badge?.badge_type === 'text'"
                            class="nav-badge"
                            :style="{
                              color: item3.badge.text_color,
                              backgroundColor: item3.badge.fill_color,
                            }"
                          >
                            {{ item3.badge.text }}
                          </span>
                          <NuxtImgWrap
                            v-else-if="item3.badge?.badge_type === 'image'"
                            class="nav-badge-image"
                            :src="item3.badge.badge_image"
                            :alt="item3.badge.alt || item3.nav_title"
                            loading="lazy"
                          />
                        </div>
                      </MagicJump>
                    </div>
                  </div>
                </div>

                <div
                  v-if="item.resource_slots?.length"
                  class="slide-panel-resources"
                  :id="`slideRight${index}`"
                >
                  <MagicJump
                    v-for="(resource, r_index) in item.resource_slots"
                    :key="resource.title"
                    :item="resource.jump_target || EMPTY_JUMP_TARGET"
                    class="resource-card"
                    :entrancePageScene="'导航栏'"
                    @click="handleResourceTrack(index, item, r_index, resource)"
                  >
                    <NuxtImgWrap
                      class="resource-image"
                      :src="resource.resource_image"
                      :alt="
                        resource.image_alt ||
                        resource.img_alt ||
                        resource.alt ||
                        `Vooglam Eyewear Collection: ${resource.title}`
                      "
                      loading="lazy"
                    />
                    <div class="resource-overlay">
                      <div class="resource-left">{{ resource.title }}</div>
                      <i v-if="resource.jump_target" class="iconfont icon-fanhui1"></i>
                    </div>
                  </MagicJump>
                </div>
              </div>
            </div>
          </li>
          <!-- endLi -->
        </ul>
        <!-- TODO: 优化：蒙层阴影做个过度动画 -->
        <div
          v-if="newNavData?.length"
          v-show="newNavData.some((item) => hasDropdown(item) && item.navShow)"
          class="slide-part-cover"
          :class="{ show: newNavData.some((item) => hasDropdown(item) && item.navShow) }"
        ></div>
        <div v-if="navScrollShow" class="scroll-btn">
          <i id="lefticon" class="iconfont icon-fanhui" @click="toscroll('left')"></i>
          <i id="righticon" class="iconfont icon-fanhui-right" @click="toscroll('right')"></i>
        </div>
      </div>
    </div>
    <div class="nav-end-inner">
      <slot name="navEnd"></slot>
    </div>

    <!-- 响应式导航 Drawer -->
    <client-only>
      <ResponsiveNavDrawer
        v-if="isMounted"
        ref="refResponsiveNavDrawer"
        :navData="newNavData"
        @navClick="handleResponsiveNavClick"
      />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import type { MagicJumpItem } from '@/api/types/magic-jump';
import type {
  NavFirstLevelItem,
  NavResourceSlot,
  NavSecondLevelItem,
  NavThirdLevelItem,
} from '@/api/types/nav';

import { useSpider } from '@/composables/useSpider';
import { useStore } from '@/store';
import { storeToRefs } from 'pinia';
import { defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';
import { EMPTY_JUMP_TARGET } from './nav';
import { formatNavPitJumpContent, useLayoutSensors } from './useLayoutSensors';

const isSpider = useSpider();
const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;
});

const ResponsiveNavDrawer = defineAsyncComponent(
  () => import('./components/ResponsiveNavDrawer.vue'),
);

const store = useStore();
const { bffSsrData } = storeToRefs(store);
const route = useRoute();
const { trackTopNavBar_Exp, trackTopNavBarTab_Click, trackTopNavBarMkt_Click } = useLayoutSensors();

interface Props {
  currentLogo?: {
    value?: number;
  };
  jumpTo?: (item: HeaderLogoInfo | null) => void;
  closeSearch?: () => void;
  SDHomeTopNavigationTabClick?: (tabName: string, tabIndex?: number) => void;
}

const props = withDefaults(defineProps<Props>(), {
  currentLogo: () => ({}),
  jumpTo: () => () => {},
  closeSearch: () => () => {},
  SDHomeTopNavigationTabClick: () => () => {},
});

interface HeaderLogoInfo {
  logo_image?: string;
  logo_ratio?: string;
  logo_sub_image?: string | null;
  logo_sub_ratio?: string;
  jump_type?: number;
  Jump_target?: string | number;
  [key: string]: unknown;
}

const logoInfo = computed<HeaderLogoInfo | null>(
  () => bffSsrData.value.logo as HeaderLogoInfo | null,
);

const routePath = computed(() => route.path);

// 响应式 drawer 相关
const refResponsiveNavDrawer = ref();

function handleResponsiveNavClick() {
  // drawer 组件内部会自动关闭，这里可以添加其他逻辑
}
const openDrawer = () => {
  refResponsiveNavDrawer.value?.openDrawer();
};

/* 导航 */
const newNavData = computed<NavFirstLevelItem[]>(() => store.bffSsrData?.top_nav || []);

function hasDropdown(item: NavFirstLevelItem) {
  return !!item.list?.length || !!item.resource_slots?.length;
}

function getFirstLevelStyle(item: NavFirstLevelItem) {
  const baseColor = item.nav_title_color ?? '#080506';
  return {
    '--nav-base-color': baseColor,
  };
}

function getTextColumnsClass(item: NavSecondLevelItem) {
  if (item.list.length > 12) {
    return 'three-columns';
  }
  if (item.list.length > 6) {
    return 'two-columns';
  }
  return '';
}

function closeOtherDropdowns(activeIndex: number) {
  newNavData.value.forEach((item, index) => {
    if (index !== activeIndex) {
      item.navShow = false;
    }
  });
}

function updateDropdownPosition(index: number) {
  // 获取DOM元素
  const dropdownLeft = document.getElementById(`slideLeft${index}`);
  const dropdownRight = document.getElementById(`slideRight${index}`);
  if (!dropdownLeft || !dropdownRight) {
    console.warn('updateDropdownPosition', dropdownLeft, dropdownRight);
    return;
  }
  const resourceItems = dropdownRight.querySelectorAll<HTMLElement>('.resource-card');
  const totalImages = resourceItems?.length || 0;

  if (!dropdownLeft || !dropdownRight || totalImages === 0) {
    console.warn('updateDropdownPosition', dropdownLeft, dropdownRight, totalImages);
    return;
  }

  /**
   * 调整布局的核心函数
   * 根据当前容器尺寸，动态调整图片宽度和显示状态
   */
  function adjustLayout() {
    // 获取左侧文字撑开的容器总高度
    let containerHeight = dropdownLeft?.clientHeight || 0;
    if (containerHeight <= 0) {
      // 容器未渲染完成，跳过
      console.warn('updateDropdownPosition--adjustLayout--containerHeight', 1);
      return;
    }
    if (containerHeight < 306) {
      containerHeight = 306;
    }

    // 获取右侧图片区域的可用宽度
    const availableWidth = dropdownRight?.clientWidth || 0;
    if (availableWidth <= 0) {
      console.warn('updateDropdownPosition--adjustLayout--availableWidth', 1);
      return;
    }

    // 计算单张图片的最大/最小宽度（基于宽高比限制）
    const maxImageWidth = containerHeight; // 1:1 宽高比时的宽度
    const minImageWidth = (containerHeight * 3) / 4; // 3:4 最小宽高比时的宽度

    // 场景1：空间足够，所有图片都可以用1:1的最大宽度显示
    const totalMaxNeeded = totalImages * maxImageWidth;
    if (totalMaxNeeded <= availableWidth) {
      resourceItems.forEach((item) => {
        if (item?.style) {
          item.style.display = 'block';
          item.style.width = `${maxImageWidth}px`;
        }
      });
      return;
    }

    // 场景2：空间不够放最大宽度，但可以放下所有图片的最小宽度
    const totalMinNeeded = totalImages * minImageWidth;
    if (totalMinNeeded <= availableWidth) {
      // 所有图片都显示，平均分配剩余空间，自动调整宽高比
      const eachWidth = Math.min(Math.floor(availableWidth / totalImages), maxImageWidth);
      resourceItems.forEach((item) => {
        item.style.display = 'block';
        item.style.width = `${eachWidth}px`;
      });
      return;
    }

    // 场景3：空间连所有图片的最小宽度都放不下，需要隐藏部分图片
    // 计算最多能显示多少张图片（每张都满足最小宽高比）
    const maxVisibleCount = Math.floor(availableWidth / minImageWidth);
    const eachWidth = Math.min(Math.floor(availableWidth / maxVisibleCount), maxImageWidth);

    // 前N张显示，剩余的隐藏
    resourceItems.forEach((item, index) => {
      if (index < maxVisibleCount) {
        item.style.display = 'block';
        // 平均分配可用宽度给显示的图片
        item.style.width = `${eachWidth}px`;
      } else {
        item.style.display = 'none';
      }
    });
  }
  adjustLayout();
}
function clearDropdownPosition(index: number) {
  const dropdownRight = document.getElementById(`slideRight${index}`);
  if (!dropdownRight) {
    console.warn('updateDropdownPosition', dropdownRight);
    return;
  }
  const resourceItems = dropdownRight.querySelectorAll<HTMLElement>('.resource-card');
  const totalImages = resourceItems?.length || 0;

  if (!dropdownRight || totalImages === 0) {
    console.warn('updateDropdownPosition', dropdownRight, totalImages);
    return;
  }
  resourceItems.forEach((item) => {
    if (item?.style) {
      item.style.display = '';
      item.style.width = '';
    }
  });
}

// 鼠标移入动效
function navMouseEnter(item: NavFirstLevelItem, index: number) {
  props.closeSearch();
  item.navShow = true;
  closeOtherDropdowns(index);
  if (item.resource_slots?.length) {
    nextTick(() => {
      updateDropdownPosition(index);
    });
  }
  if (hasDropdown(item)) {
    trackTopNavBar_Exp(index, item.nav_title);
  }
}

function navMouseLeave(item: NavFirstLevelItem, index: number) {
  item.navShow = false;
  if (item.resource_slots?.length) {
    nextTick(() => {
      // 把资源位设置的图片样式给移除，避免下次展开时影响宽度计算
      clearDropdownPosition(index);
    });
  }
}

// 监听页面屏幕宽度变化，一级导航滚动展示
const navScrollShow = ref(false);
onMounted(() => {
  window.addEventListener('resize', updateScreenWidth);
  updateScreenWidth();
});
function updateScreenWidth() {
  if (!newNavData.value?.length) {
    return;
  }
  newNavData.value.forEach((item) => {
    item.navShow = false;
  });
  // 获取二级导航ul宽度
  const eleUl = document.querySelectorAll<HTMLElement>('.nav-wrapper .nav-box .vooglam-nav li');
  let ulWidth = 0;
  if (eleUl.length) {
    eleUl.forEach((item) => {
      ulWidth += item.offsetWidth;
    });
  }
  // 获取ul父级宽度
  const eleFath = document.querySelector<HTMLElement>('.nav-wrapper .nav-box');
  if (eleFath) {
    if (ulWidth > eleFath.offsetWidth) {
      navScrollShow.value = true;
    } else {
      navScrollShow.value = false;
    }
  }
}
// 组件销毁移除屏幕监听
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScreenWidth);
});

function resolveNavTargetUrl(item: MagicJumpItem | null | undefined = EMPTY_JUMP_TARGET) {
  if (!item) {
    return '';
  }
  const jump_type = item.jump_type;
  const Jump_target =
    typeof item.Jump_target === 'number' ? String(item.Jump_target) : item.Jump_target;
  if (!Jump_target) {
    return '';
  }
  const hostArr = ['www.vooglam', 'm.vooglam', 'www-vooglam', 'm-vooglam'];
  let url = '';
  switch (jump_type) {
    case 1:
      url = `/goods-list/${Jump_target}`;
      break;
    case 2:
      url = `/goods-detail/${Jump_target}`;
      break;
    case 3:
      url = Jump_target;
      break;
    case 4:
      if (hostArr.some((target) => Jump_target?.includes(target))) {
        const href = new URL(Jump_target);
        url = href.href.replace(href.origin, '');
      } else {
        url = Jump_target;
      }

      break;
  }
  return url;
}

const navIsHover = function (item: MagicJumpItem | null | undefined = EMPTY_JUMP_TARGET) {
  return routePath.value === resolveNavTargetUrl(item);
};

function handleThirdLevelTrack(
  index: number,
  item: NavFirstLevelItem,
  index2: number,
  item2: NavSecondLevelItem,
  index3: number,
  item3: NavThirdLevelItem,
) {
  trackTopNavBarTab_Click(index, item.nav_title, index2, item2.nav_title, index3, item3.nav_title);
  navMouseLeave(item, index);
}

function handleImageTrack(
  index: number,
  item: NavFirstLevelItem,
  index2: number,
  item2: NavSecondLevelItem,
  index3: number,
  item3: NavThirdLevelItem,
) {
  trackTopNavBarMkt_Click(index, item.nav_title, {
    second_level_index: index2,
    second_level_nav: item2.nav_title,
    pits_index: index3,
    pits_jump_type: item3.jump_target?.jump_type,
    pits_jump_content: formatNavPitJumpContent(item3.jump_target),
    pits_title: item3.nav_title || '',
  });
  navMouseLeave(item, index);
}

function handleResourceTrack(
  index: number,
  item: NavFirstLevelItem,
  r_index: number,
  resource: NavResourceSlot,
) {
  trackTopNavBarMkt_Click(index, item.nav_title, {
    second_level_nav: 'ziyuanwei',
    pits_index: r_index,
    pits_jump_type: resource.jump_target?.jump_type,
    pits_jump_content: formatNavPitJumpContent(resource.jump_target),
    pits_title: resource.title || '',
  });
  navMouseLeave(item, index);
}

function toscroll(val: 'left' | 'right') {
  const startLi = document.querySelector<HTMLElement>('#startLi');
  const endLi = document.querySelector<HTMLElement>('#endLi');
  const leftIcon = document.querySelector<HTMLElement>('#lefticon');
  const rightIcon = document.querySelector<HTMLElement>('#righticon');

  if (val === 'left') {
    startLi?.scrollIntoView();
    if (leftIcon) {
      leftIcon.style.color = '#A8A8A8';
    }
    if (rightIcon) {
      rightIcon.style.color = '#080506';
    }
  } else {
    endLi?.scrollIntoView();
    if (rightIcon) {
      rightIcon.style.color = '#A8A8A8';
    }
    if (leftIcon) {
      leftIcon.style.color = '#080506';
    }
  }
}
function goHome() {
  props.jumpTo(logoInfo.value);
  props.SDHomeTopNavigationTabClick('Logo');
}

defineExpose({
  updateScreenWidth,
});
</script>

<style lang="scss" scoped>
.nav-box {
  // position: relative;
  display: flex;
  width: px-vw-max(520px);
  font-family: $f-pr;
  color: #080506;
  flex-direction: row;
  flex: 1;
  .scroll-btn {
    @include flex(center, center);
    i {
      padding: 0 5px;
      font-size: 12px;
      color: #080506;
      cursor: pointer;
    }
  }
}
.nav-wrapper {
  @include flex(space-between, center);

  position: relative;
  margin: 0 auto;
  padding: 0 px-vw-max(72px);
  max-width: 2560px;
  box-sizing: border-box;
  height: 66px;
  background: white;
  .nav-end-inner {
    @include flex(normal, center);
  }
  .nav-left-inner {
    @include flex(normal, center);

    flex: 1;
    .responsive-menu-btn {
      display: none;
      justify-content: center;
      align-items: center;
      margin-right: 16px;
      width: 48px;
      height: 66px;
      cursor: pointer;
      box-sizing: border-box;
      i {
        font-size: 24px;
        color: #080506;
      }
      &:hover {
        i {
          color: $origin;
        }

        background: rgba(254, 80, 0, 0.08);
        &::before {
          display: block;
        }
      }
      &::before {
        content: '';
        position: absolute;
        bottom: 1px;
        display: none;
        width: 24px;
        height: 3px;
        border-radius: 10px 10px 0 0;
        background-color: $origin;
      }
    }
    .header-inner-middle {
      @include flex(center, center);

      margin-right: 40px;
      cursor: pointer;
      a,
      img {
        display: block;
      }
    }
  }
}
.slide-part-cover {
  position: absolute;
  left: 0;
  right: 0;
  top: 66px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
}
.vooglam-nav {
  @include flex(normal, center);

  overflow: auto hidden;
  width: 100%;
  height: 66px;
  white-space: nowrap;
  background: #ffffff;
  flex: 1;
  img {
    display: block;
    max-width: 100%;
  }
  .nav-li {
    --nav-base-color: #1a1c1e;

    @include flex($col: center);

    height: 100%;
    line-height: 100%;
    font-size: 16px;
    flex-shrink: 0;
    &:hover {
      .nav-inner-title .title {
        color: $origin !important;
        &::after {
          left: 0;
          width: 100%;
          border-radius: 10px 10px 0 0;
        }
      }
    }
    :deep(.nav-li-a) {
      padding-right: 20px;
      padding-left: 20px;
      height: 100%;
      color: inherit;
      cursor: pointer;
    }
    &.on {
      .nav-inner-title .title {
        color: $origin !important;
      }
    }
    .nav-inner-title {
      position: relative;
      display: inline-flex;
      align-items: center;
      height: 100%;
      color: var(--nav-base-color);
      .title {
        position: relative;
        display: block;
        font-family: $f-pm;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -23px;
          width: 0;
          height: 3px;
          background-color: var(--origin, #fe5000);
          transition: all 0.3s;
        }
      }
    }
  }
  .nav-badge {
    margin-left: 6px;
    padding: 0 4px;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    color: #271717;
    background: #ecdaa8;
    &.nav-title-badge {
      padding: 0 2px;
      height: 14px;
      line-height: 14px;
      color: white;
      background: #a42e28;
    }
  }
  .nav-badge-image {
    margin-left: 6px;
    width: auto;
    height: 18px;
  }
  .slide-part {
    position: absolute;
    z-index: 3000;
    left: 0;
    right: 0;
    top: 66px;
    padding-right: clamp(48px, 48px + (100vw - 1280px) * 0.0375, 72px);
    padding-left: clamp(48px, 48px + (100vw - 1280px) * 0.0375, 72px);
    width: 100vw;
    max-width: 2560px;
    min-height: 306px;
    max-height: 70vh;
    border-top: 1px solid #e3e1de;
    background: rgba(255, 255, 255, 0.86);
    backdrop-filter: blur(80px);
    box-sizing: border-box;
    &.has-resource {
      padding-right: 0;
    }

    @include flex(space-between, flex-start);

    column-gap: 24px;
    .slide-panel-groups {
      @include flex(normal, flex-start);

      gap: clamp(16px, 16px + (100vw - 1280px) * 0.0125, 24px);
      padding-top: 32px;
      padding-bottom: 40px;
      flex: 0;
    }
    .slide-panel-resources {
      display: flex;
      justify-content: flex-end;
      align-self: stretch;

      // 这里必须加，否则，资源位没有宽度，影响图片计算宽度
      flex-grow: 1;
      .resource-card {
        position: relative;
        display: none;
        overflow: hidden;
        background: #ffffff;
      }
      .resource-image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .resource-overlay {
        @include flex(space-between, center);

        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 16px;
        color: #ffffff;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
        i {
          margin-left: 12px;
          font-size: 18px;
          transform: rotate(180deg);
        }
      }
      .resource-left {
        line-height: 24px;
        white-space: wrap;
        font-size: 16px;
        font-family: $f-psb;
      }
      .resource-description {
        line-height: 16px;
        font-size: 12px;
        font-family: $f-lr;
      }
    }
    .second-box {
      padding-right: clamp(16px, 16px + (100vw - 1280px) * 0.0125, 24px);
      min-width: clamp(180px, 180px + (100vw - 1280px) * 0.0313, 200px);
      box-sizing: border-box;
      &.display-image {
        padding-right: 0;
      }
    }
    .nav-group-title {
      @include flex(normal, center);

      margin-bottom: 16px;
      .item2-title {
        line-height: 26px;
        font-size: 16px;
        font-family: $f-psb;
        font-weight: normal;
      }
    }
    .second-text-box {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      font-size: 16px;
      font-family: $f-lr;
      cursor: pointer;
      .magic-jump {
        display: inline-flex;
        align-items: center;
        text-decoration: none;
        color: #080506;
        &:hover .third-level-title {
          color: $origin !important;
        }
      }
      .third-level-title {
        line-height: 20px;
        font-size: 14px;
        font-family: $f-lr;
        word-break: break-word;
      }
    }
    .second-image-box {
      display: flex;
      gap: 8px;
      scrollbar-width: none;
      overflow-x: auto;
      box-sizing: border-box;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .second-image-content {
        flex-shrink: 0;
        display: block;
        box-sizing: border-box;
        width: clamp(178px, 178px + (100vw - 1280px) * 0.2, 306px);
        text-decoration: none;
        color: #080506;
        .second-image-content-img {
          width: 100%;
          aspect-ratio: 1 / 1;
          object-fit: cover;
        }
      }
      .second-image-btm {
        margin-top: 8px;

        @include flex(flex-start, center, row, wrap);

        column-gap: 6px;
        row-gap: 4px;
        .shape-title {
          min-width: 0;
          max-width: 100%;
          line-height: 20px;
          font-size: 14px;
          font-family: $f-lr;
          word-break: break-word;
        }
        .nav-badge,
        .nav-badge-image {
          flex-shrink: 0;
          margin-left: 0;
        }
      }
    }
  }
}

// 响应式样式
@media screen and (max-width: 1280px) {
  .nav-wrapper {
    .nav-left-inner {
      .responsive-menu-btn {
        display: flex;
      }
    }
    .nav-box {
      display: none;
    }
  }
}
</style>
